<div class="flex flex-col gap-8">
  <div>
    <homey-page-title-layout>
      About us
    </homey-page-title-layout>
    <homey-paragraphs>
      <p>Finding an affordable home in NYC shouldn't be complicated, we want to make it possible for every New Yorker to
        do so.</p>

      <p>We believe everyone deserves a fair shot at affordable housing. Right now, the confusing paperwork and
        bureaucratic hurdles make it so that only people with enough time and administrative skills can apply. Too many
        people give up on the NYC Housing Lottery because the process is just too overwhelming.</p>

      <p>We want to make the process truly accessible, so everyone has the same chance of winning a home that fits their
        needs, regardless of their background.</p>
    </homey-paragraphs>
  </div>
  <div class="flex flex-row gap-6 justify-center mt-4">
    <div>
      <img src="assets/images/wout.jpg" alt="Wout" class="size-[8rem] object-cover rounded-xl"/>
      <p class="text-surface-500 text-center mt-2">Wout Stienaers</p>
    </div>
    <p class="text-surface-500 text-center self-end">&</p>
    <div>
      <img src="assets/images/piet.jpeg" alt="Piet" class="size-[8rem] object-cover rounded-xl"/>
      <p class="text-surface-500 text-center mt-2">Piet Goris</p>
    </div>
  </div>
</div>
@let userData = user();
@if (!userData || userData.status === 'unauthorized') {
  <homey-lotteries-and-footer/>
}
